import PanelResizer from '~/vue_shared/components/panel_resizer.vue';
import LocalStorageSync from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/local_storage_sync.vue?vue3';
import { WIKI_SIDEBAR_WIDTH_CSS_VAR, WIKI_SIDEBAR_WIDTH_STORAGE_KEY, WIKI_SIDEBAR_DEFAULT_WIDTH } from '~/wikis/constants';
import { getWikiOverviewEl } from '~/wikis/utils/sidebar_toggle';
export default {
    name: 'SidebarResizer',
    storageKey: WIKI_SIDEBAR_WIDTH_STORAGE_KEY,
    components: {
        PanelResizer,
        LocalStorageSync
    },
    data () {
        return {
            defaultWidth: WIKI_SIDEBAR_DEFAULT_WIDTH,
            sidebarWidth: WIKI_SIDEBAR_DEFAULT_WIDTH,
            minWidth: 200,
            maxWidth: 600
        };
    },
    mounted () {
        this.applySidebarWidth();
        this.getSidebarContainer().classList.remove('gl-hidden');
        requestAnimationFrame(this.restoreTransitions);
    },
    methods: {
        getSidebarContainer () {
            return document.querySelector('.sidebar-container');
        },
        getSidebar () {
            return document.querySelector('.wiki-sidebar');
        },
        removeTransitions () {
            this.getSidebar().classList.remove('transition-enabled');
        },
        restoreTransitions () {
            this.getSidebar().classList.add('transition-enabled');
        },
        applySidebarWidth () {
            getWikiOverviewEl()?.style.setProperty(WIKI_SIDEBAR_WIDTH_CSS_VAR, `${this.sidebarWidth}px`);
        },
        updateWidth (width) {
            this.removeTransitions();
            this.sidebarWidth = width;
            this.applySidebarWidth();
            requestAnimationFrame(this.restoreTransitions);
        },
        resetSize () {
            this.updateWidth(this.defaultWidth);
        }
    }
};
